export enum ButtonType {
	Button = 'button',
	Submit = 'submit',
	Reset = 'reset',
}